import { FC } from "react";
import css from './index.module.css';
import useUserData from "@hooks/useUserData";

interface Tabs {
  active?: number
  setActive?: any
  isFull?: boolean
  vertical?: boolean
}

const Tabs:FC<Tabs> = ({ active, setActive }) => {
  const { userData } = useUserData();

  return (
    <div className={css.sections}>
      <div className={`${css.section} ${active === 0 ? css.active : ''}`} onClick={() => setActive(0)}>Мои заказы</div>
      <div className={`${css.section} ${active === 7 ? css.active : ''}`} onClick={() => setActive(7)}>Уведомления ({userData.unreadNotifications || 0})</div>
      <div className={`${css.section} ${(active === 3 || active === 4) ? css.active : ''}`} onClick={() => setActive(3)}>Адреса</div>
      <div className={`${css.section} ${(active === 5 || active === 6) ? css.active : ''}`} onClick={() => setActive(5)}>Организации</div>
      <div className={`${css.section} ${active === 1 ? css.active : ''}`} onClick={() => setActive(1)}>Настройки</div>
      <div className={`${css.section} ${active === 2 ? css.active : ''}`} onClick={() => setActive(2)}>О нас</div>
      <i className={`fi fi-rr-angle-small-right ${css.arrow}`}></i>
    </div>
  );
};

export default Tabs;